import { render, staticRenderFns } from "./ServicioSocialReportesPage.vue?vue&type=template&id=d8e4dd5a&scoped=true&"
import script from "./ServicioSocialReportesPage.vue?vue&type=script&lang=js&"
export * from "./ServicioSocialReportesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e4dd5a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialReportesPage.vue
// module id = 218
// module chunks = 9